import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
};

export function UnstyledFooter({ classes }) {
  return (
    <footer className={classes.footer}>
      © ObjectRocket, a Rackspace Company |{' '}
      <a href="https://www.objectrocket.com/terms-of-service" className={classes.footerLink}>
        Terms&nbsp;of&nbsp;Service
      </a>{' '}
      |{' '}
      <a href="https://www.objectrocket.com/legal" className={classes.footerLink}>
        Legal
      </a>{' '}
      |{' '}
      <a
        href="https://www.rackspace.com/information/legal/privacystatement"
        className={classes.footerLink}
      >
        Privacy&nbsp;Policy
      </a>
    </footer>
  );
}

UnstyledFooter.propTypes = propTypes;

const styles = (theme) => ({
  footer: {
    backgroundColor: theme.customColors.darkGrey,
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    fontSize: '0.8571428571rem',
    // Make sure it's above the summary drawer in the create flow
    zIndex: 1201,

    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      paddingLeft: 'unset',
      fontSize: '0.7142857143rem',
    },
  },
  footerLink: {
    color: theme.customColors.white,
    textDecoration: 'none',
  },
});

export default withStyles(styles)(UnstyledFooter);
